import { ManageTable, type ManageField } from '@/components/ManageTable'
import { Input } from '@/components/ui/input'
import { usePersistentState } from '@/hooks/usePersistentState'

export default function Cost() {
  const [filters, setFilter, clearFilters] = usePersistentState<Record<string, any>>(
    'admin:cost:filters',
    {},
  )

  const handleResetFilters = () => {
    clearFilters()
  }

  const fields: ManageField[] = [
    {
      desc: 'plat',
      field: 'plat',
    },
    {
      desc: 'account',
      field: 'account',
    },
    {
      desc: 'income',
      field: 'income',
    },
    {
      desc: 'desc',
      field: 'des',
    },
    {
      desc: 'cur',
      field: 'cur',
    },
    {
      desc: '备注',
      field: 'desc',
    },
    {
      desc: '更新时间',
      field: 'update_time',
    },
    {
      desc: '创建时间',
      field: 'create_time',
    },
  ]

  const filterUI = (
    <Input
      placeholder="输入 account"
      className="w-[200px]"
      value={filters.account || ''}
      onChange={(e) => {
        if (e.target.value) {
          setFilter({ account: e.target.value })
        } else {
          setFilter({})
        }
      }}
    />
  )

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">成本管理</h1>
      <ManageTable fields={fields} collect="cost" filters={filters} filter={filterUI} onResetFilters={handleResetFilters} />
    </div>
  )
}
